import { zodResolver } from '@hookform/resolvers/zod'
import { useTranslation } from 'next-i18next'
import { DOMAttributes } from 'react'
import { SubmitHandler, useForm } from 'react-hook-form'
import { REQUIRED_CHAR } from 'utils/constants'
import handleFormError from 'utils/handleFormError'

import * as S from './styles'
import schema, { FormProps } from './validator'

export interface ForgotPasswordFormProps {
  onSubmit: (data: FormProps) => Promise<void>
  onGoBack: () => void
  isLoading?: boolean
}

const ForgotPasswordForm = ({
  onSubmit,
  onGoBack,
  isLoading,
}: ForgotPasswordFormProps) => {
  const { t } = useTranslation('forgot-password')

  const {
    register,
    formState: { errors, isSubmitted, isValid },
    handleSubmit,
    setError,
    trigger,
  } = useForm<FormProps>({
    resolver: zodResolver(schema),
  })

  const onFormValid: SubmitHandler<FormProps> = data => {
    onSubmit(data)
      .catch(error => handleFormError(error, setError))
      .finally(trigger)
  }

  const handleGoBack: DOMAttributes<HTMLButtonElement>['onClick'] = event => {
    event.preventDefault()
    onGoBack()
  }

  return (
    <S.Form onSubmit={handleSubmit(onFormValid)}>
      <S.EmailField
        name="email"
        label={t('email') + REQUIRED_CHAR}
        placeholder={t('email-placeholder')}
        register={register}
        errors={errors}
      />
      <S.Description>{t('description')}</S.Description>
      <S.SubmitButton disabled={isLoading || (isSubmitted && !isValid)}>
        {t('send')}
      </S.SubmitButton>
      <S.BackButton onClick={handleGoBack}>
        {t('go-back-to-login')}
      </S.BackButton>
    </S.Form>
  )
}

export default ForgotPasswordForm
